
import { Options, Vue, Prop } from "vue-property-decorator";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import { namespace } from "vuex-class";
import OverlayPanel from "primevue/overlaypanel";

const AuthModule = namespace("auth");
@Options({
  components: { Breadcrumbs },
})
export default class CrudLayout extends Vue {
  public name = "CrudLayout";
  @Prop({ default: false })
  public showAside!: boolean;

  @AuthModule.Action("signOut")
  protected signOutAction: any;

  @AuthModule.Getter("getDataItem")
  private user: any;

  get syncedShowAside(): boolean {
    return this.showAside;
  }
  set syncedShowAside(value: boolean) {
    this.$emit("onShowAsideChange", value);
  }

  private goToHome(): void {
    this.$router.push({ name: "Home" });
  }
  private goToEditProfile(): void {
    this.$router.push({ name: "UserProfile" });
  }

  private toggleProfilePanel(event: any): void {
    console.log(this.user);
    if (this.$refs.profilePanel) {
      (this.$refs.profilePanel as OverlayPanel).toggle(event);
    }
  }

  private logout(): void {
    this.signOutAction();
  }
}
